import { render, staticRenderFns } from "./form-shop-card.app.vue?vue&type=template&id=5d54eeb5&"
import script from "./form-shop-card.app.vue?vue&type=script&lang=js&"
export * from "./form-shop-card.app.vue?vue&type=script&lang=js&"
import style0 from "./form-shop-card.app.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports